module.exports = __webpack_public_path__ + "img/pelleter.962972fc.png";